module.exports = __webpack_public_path__ + "img/LogoB&W.003cd28a.png";